var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDepoimg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42077 0.43063C1.32322 0.430092 1.22647 0.448189 1.13572 0.483949C0.954564 0.557665 0.809563 0.699504 0.73187 0.878989C0.694119 0.968933 0.673893 1.06526 0.67228 1.1628L0.488692 17.8943C0.486538 18.0906 0.562474 18.2798 0.699796 18.4202C0.837119 18.5606 1.02458 18.6407 1.22093 18.6429C1.41729 18.645 1.60646 18.5691 1.74683 18.4318C1.8872 18.2945 1.96727 18.107 1.96943 17.9107L2.13135 2.96317L17.4309 18.6038C17.568 18.744 17.7553 18.824 17.9514 18.8262C18.1475 18.8283 18.3364 18.7525 18.4766 18.6154C18.6168 18.4783 18.6968 18.291 18.6989 18.0949C18.7011 17.8988 18.6252 17.7099 18.4881 17.5697L3.18854 1.92903L18.135 2.09562C18.3313 2.09779 18.5205 2.02188 18.6609 1.88457C18.8012 1.74726 18.8813 1.55981 18.8835 1.36345C18.8856 1.16709 18.8097 0.977912 18.6723 0.837528C18.535 0.697145 18.3476 0.617055 18.1512 0.614881L1.42077 0.43063Z",
    fill: "#017FDA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepoimg);
export default __webpack_public_path__ + "static/media/depoimg.b1c0d418.svg";
export { ForwardRef as ReactComponent };